import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { useUpdateDeliveryConditionMutation } from "@/services/backend/deliveries/delivery/service";
import { Condition } from "@/services/backend/deliveries/state/state";
import { useState } from "react";
import { packageConditions } from "@/shared/components/enum-labels";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";

interface UpdateDeliveryConditionProps {
  deliveryId: string;
  currentCondition?: string;
  disabled?: boolean;
}

export function UpdateDeliveryCondition({
  deliveryId,
  currentCondition,
  disabled = false,
}: UpdateDeliveryConditionProps) {
  const [state, setState] = useState(currentCondition || "");
  const [updateDeliveryState, { error }] = useUpdateDeliveryConditionMutation();

  function onChange(newCondition: string) {
    setState(newCondition);
    updateDeliveryState({
      id: deliveryId,
      condition: newCondition as Condition,
    });
  }

  return (
    <>
      <Select
        disabled={disabled}
        onValueChange={(val) => onChange(val)}
        defaultValue={state}
      >
        <SelectTrigger
          className="w-full"
          defaultValue={currentCondition || "fine"}
        >
          <SelectValue placeholder="Zustand auswählen" />
        </SelectTrigger>
        <SelectContent defaultValue={currentCondition || "fine"}>
          {Object.values(Condition).map((value) => (
            <SelectItem key={`${deliveryId}-${value}`} value={value}>
              {packageConditions[value]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <RTKQueryErrorAlert error={error} />
    </>
  );
}
